import { requestApi } from 'api/api'
import { EarnDashboardResponse } from 'types/earn'

export const getEarnDashboard = async (): Promise<EarnDashboardResponse> => {
  return requestApi({
    url: '/earn/dashboard',
    baseUrl: process.env.API_URL,
    method: 'GET',
  })
}
